import React from 'react';
import { DropdownButton, MenuItem, Label } from 'react-bootstrap';
import { GiWindsock } from "react-icons/gi";
import { CgFormatText } from "react-icons/cg";
import { ImPower } from "react-icons/im";
import { TbSolarPanel } from "react-icons/tb";
import { LuFilter, LuFilterX, LuArrowDownWideNarrow } from "react-icons/lu";
import { IoShieldCheckmark, IoShieldCheckmarkOutline, IoWarningOutline } from "react-icons/io5";
import { FaLink, FaUnlink, FaChartLine, FaRegPlayCircle, FaTools } from "react-icons/fa";
import { PiTrafficConeLight } from "react-icons/pi";
import services from './../../lib/Services';

/**
 * Sorting bar: Header of the Table.
 * @copyright Optimum Tracker
 * @author wkoffi
 */
class SortingBarTableHeader extends React.Component
{
    render()
    {
        return (
            <thead>
                <tr className="sorting-bar-bg">
                    <th className="border-sorting-bar">
                        <div className="sorting-bar-actions">
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                            <DropdownButton bsStyle="default" title={<LuFilter />} noCaret id="dropdown-status" className="font-sorting-bar-text text-trackers">
                                <MenuItem eventKey="1" onClick={() => this.props.setFiltering('status', null)}>
                                    <LuFilterX />
                                    <span className="font-sorting-bar-text-blue">All</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="2" onClick={() => this.props.setFiltering('status', 0)}>
                                    <LuFilter />
                                    <FaLink color="green" />
                                    <span className="font-sorting-bar-text-blue">OK</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="3" onClick={() => this.props.setFiltering('status', 1)}>
                                    <LuFilter />
                                    <FaUnlink color="#d9534f" />
                                    <span className="font-sorting-bar-text-blue">KO</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="4" onClick={() => this.props.setFiltering('status', 2)}>
                                    <LuFilter />
                                    <FaLink color="orange" />
                                    <span className="font-sorting-bar-text-blue">Warning</span>
                                </MenuItem>
                            </DropdownButton>
                         </div>
                    </th>
                    { services.getUser().isSuperAdmin() && (<th className="border-sorting-bar">
                        <div className="sorting-bar-actions">
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                            <DropdownButton bsStyle="default" title={<FaRegPlayCircle />} noCaret id="dropdown-step" className="font-sorting-bar-text text-trackers">
                                <MenuItem eventKey="0" onClick={() => this.props.setFiltering('step', 0)}>
                                    <LuFilter />
                                    <FaRegPlayCircle color="green" />
                                    <span className="font-sorting-bar-text-blue">In operation</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="1" onClick={() => this.props.setFiltering('step', 1)}>
                                    <LuFilter />
                                    <PiTrafficConeLight color="orange" />
                                    <span className="font-sorting-bar-text-blue">Wait for commissioning</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="2" onClick={() => this.props.setFiltering('step', 2)}>
                                    <LuFilter />
                                    <FaTools color="brown" />
                                    <span className="font-sorting-bar-text-blue">Building</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="3" onClick={() => this.props.setFiltering('step', null)}>
                                    <LuFilterX />
                                    <span className="font-sorting-bar-text-blue">All</span>
                                </MenuItem>
                            </DropdownButton>
                        </div>
                    </th> )}
                    <th className="border-sorting-bar">
                        <div className="sorting-bar-actions">
                            <LuArrowDownWideNarrow onClick={() => this.props.setSorting('name')} className="sorting-bar-hover" />
                            <CgFormatText size={20} color="black" />   
                            <DropdownButton bsStyle="default" title={<LuFilter />} noCaret id="dropdown-status" className="font-sorting-bar-text text-trackers">
                                <MenuItem eventKey="1">
                                    <input type="text" className="filterByName" onClick={e => e.stopPropagation()} onBlur={(e) => this.props.setFiltering('name', e.target.value)}/>
                                </MenuItem>
                            </DropdownButton>
                        </div>
                    </th>
                    <th className="border-sorting-bar">
                        <div className="sorting-bar-actions">
                            <LuArrowDownWideNarrow onClick={() => this.props.setSorting('power')} className="sorting-bar-hover" />
                            <ImPower size={15} color="yellow" />
                            <span>&nbsp;</span>
                        </div>
                    </th>
                    <th colSpan="2" className="text-center border-sorting-bar">
                        <div className="sorting-bar-actions">
                            <DropdownButton bsStyle="default" title={<LuArrowDownWideNarrow />} noCaret id="dropdown-trackers" className="font-sorting-bar-text text-trackers">
                                <MenuItem eventKey="1" onClick={() => this.props.setSorting('percentAuto')}>
                                    <LuArrowDownWideNarrow />
                                    <TbSolarPanel style={{verticalAlign: 'middle'}} color="green" size={20} />
                                    <span className="font-sorting-bar-text-blue">Trackers ON</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="2" onClick={() => this.props.setSorting('nbTrackersManual')}>
                                    <LuArrowDownWideNarrow />
                                    <TbSolarPanel style={{verticalAlign: 'middle'}} color="orange" size={20} />
                                    <span className="font-sorting-bar-text-blue">Trackers Manual</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="3" onClick={() => this.props.setSorting('nbTrackersError')}>
                                    <LuArrowDownWideNarrow />    
                                    <TbSolarPanel style={{verticalAlign: 'middle'}} color="red" size={20} />
                                    <span className="font-sorting-bar-text-blue">Trackers OFF</span>
                                </MenuItem>
                            </DropdownButton>
                            <div className="sorting-bar-label">
                                <TbSolarPanel color="rgb(91, 192, 222)" size={20} />
                                <span>Trackers</span>
                            </div>
                            <span>&nbsp;</span>
                        </div>
                    </th>
                    <th colSpan="2" className="text-center border-sorting-bar">
                        <div className="sorting-bar-actions">
                            <span>&nbsp;</span>
                            <div className="sorting-bar-label">
                                <GiWindsock size={20} color="red" />
                                <span>Wind</span>
                            </div>
                            <DropdownButton bsStyle="default" title={<LuFilter />} noCaret id="dropdown-wind" className="font-sorting-bar-text text-trackers">
                                <MenuItem eventKey="1" onClick={() => this.props.setFiltering('safety', null)}>
                                    <LuFilterX />
                                    <span className="font-sorting-bar-text-blue">All</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="2" onClick={() => this.props.setFiltering('safety', true)}>
                                    <LuFilter />
                                    <IoShieldCheckmark color="orange" />
                                    <span className="font-sorting-bar-text-blue">Safety ON</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="3" onClick={() => this.props.setFiltering('safety', false)}>
                                    <LuFilter />
                                    <IoShieldCheckmarkOutline />
                                    <span className="font-sorting-bar-text-blue">Safety OFF</span>
                                </MenuItem>
                            </DropdownButton>
                        </div>
                    </th>
                    { services.getUser().isSuperAdmin() && (<th className="text-center border-sorting-bar">
                        <div className="sorting-bar-actions">
                            <span>&nbsp;</span>
                            <div className="sorting-bar-label">
                                <IoWarningOutline size={20} color="orange" />
                                <span>Warnings</span>
                            </div>
                            <DropdownButton bsStyle="default" title={<LuFilter />} noCaret pullRight id="dropdown-warning" className="font-sorting-bar-text text-trackers">
                                <MenuItem eventKey="1" onClick={() => this.props.setFiltering('warning', null)}>
                                    <LuFilterX />
                                    <span className="font-sorting-bar-text-blue">All</span>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="2" onClick={() => this.props.setFiltering('warning', 1)}>
                                    <LuFilter />
                                    <Label bsStyle="danger">Error</Label>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="3" onClick={() => this.props.setFiltering('warning', 2)}>
                                    <LuFilter />
                                    <Label bsStyle="warning">Warning</Label>
                                </MenuItem>
                            </DropdownButton>
                        </div>
                    </th> )}
                    { services.getUser().isSuperAdmin() && (<th className="text-center border-sorting-bar">
                        <div className="sorting-bar-actions">
                            <LuArrowDownWideNarrow onClick={() => this.props.setSorting('availability')} className="sorting-bar-hover" />
                            <FaChartLine size={20} color="green"/>
                            <span>%</span>
                        </div>
                    </th> )}
                    <th className="border-sorting-bar"></th>
                </tr>
        </thead>
    );
  }

}

SortingBarTableHeader.defaultProps = {
    setSorting: function(){},
    setFiltering: function(){}
};
export default SortingBarTableHeader;